'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropSquare = function ImageCropSquare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z' })
  );
};
ImageCropSquare = (0, _pure2.default)(ImageCropSquare);
ImageCropSquare.displayName = 'ImageCropSquare';
ImageCropSquare.muiName = 'SvgIcon';

exports.default = ImageCropSquare;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/crop-square.js
// module id = 2379
// module chunks = 0